export { KEYS } from './api-keys';
export const DEFAULT_KEY = 'no-key-available-for-current-domain';
